const getters = {
  mapBackground: state => state.common.mapBackground
}
export default getters
